import React, {
  useState, useContext, useCallback,
} from 'react';
import { Button, Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { EditorControls, EditorStingInput } from '../../../basicEditor/editorControls';
import OldEditor from './oldSign';
import NewEditor from './newEditor';
import { LogicaContext } from '../../../../providers';

export const widgetModes = {
  iit: 'iit',
  diya: 'diya',
  ciat: 'ciat',
};

function LogcaLogin({ onSuccess, getUserData }) {
  const {
    ticket, onLogin, widgetMode, setWidgetMode, onLogout,
  } = useContext(LogicaContext);

  const [inputToken, setInputToken] = useState('');

  const logIn = useCallback(
    (t) => {
      onLogin(t);
      if (onSuccess) onSuccess();
    },
    [onLogin, onSuccess],
  );
  if (widgetMode === null) return null;

  return (
    <div className="mt-4">
      <Collapse in={!!ticket}>
        <Button variant="outline-warning" onClick={() => onLogout()}>
          <FontAwesomeIcon icon={faRefresh} className="me-2" />
          Закінчити сесію (переавторизуватися)
        </Button>
      </Collapse>
      {!ticket && widgetMode !== widgetModes.ciat && (
        <OldEditor
          onSuccess={onSuccess}
          getUserData={getUserData}
        />
      )}
      {!ticket && widgetMode === widgetModes.ciat && (
        <NewEditor
          onLogin={logIn}
        />
      )}
      {process.env.NODE_ENV === 'development' && (
        <div>
          <EditorStingInput
            label="Logika ticket"
            maxLength={36}
            description="Це поле доступно тільки в режимі розробки."
            value={inputToken}
            onChange={(e, v) => setInputToken(v)}
            append={(
              <Button
                variant="outline-secondary"
                disabled={inputToken.length !== 36}
                onClick={() => {
                  onLogin({
                    ticket: inputToken,
                    organizationId: '12345678',
                    organizationName: 'CIAT developer company',
                    subject: 'CIAT developer',
                  });
                  if (onSuccess) onSuccess();
                }}
              >
                Login
              </Button>
            )}
          />
        </div>
      )}
      {!ticket && (

      <div className="mt-5 mx-2">
        <EditorControls.CheckboxInput
          controlId="IIT-widget"
          label="Використовувати віджет"
          value={widgetMode === widgetModes.iit}
          onChange={(e, v) => setWidgetMode(v ? widgetModes.iit : widgetModes.ciat)}
        />
      </div>
      )}
    </div>
  );
}

LogcaLogin.propTypes = {
  onSuccess: PropTypes.func,
  getUserData: PropTypes.func,
};

LogcaLogin.defaultProps = {
  onSuccess: null,
  getUserData: null,
};

export default LogcaLogin;
